<template>
  <th v-if="isHeader">
    {{rowField.title | translate}}
  </th>
  <td v-else>
  <div class="custom-actions">
    <span v-if="isDeleted && rowField.model !== 'delete'" class="text-muted pipe-deleted">{{ rowData[rowField.model] }}</span>
    <span v-else-if="inputType(rowField.model).type == 'readonly'">{{ rowData[rowField.model] }}</span>
    <input v-else-if="inputType(rowField.model).type == 'number'" style="width:100%" type="number" class="form-control" @change="itemAction('update-field', rowData.id, rowField.model, rowData)" v-model="rowData[rowField.model]"></input>
    <input v-else-if="inputType(rowField.model).type == 'text'" style="width:100%" type="text" class="form-control" @change="itemAction('update-field', rowData.id, rowField.model, rowData)" v-model="rowData[rowField.model]"></input>
    <a href="#" v-if="rowField.model === 'delete' && !isDeleted" @click.prevent="itemAction('delete-row', rowData.id, rowField.model, rowData)">x</a>
    <a href="#" v-if="rowField.model === 'delete' && isDeleted" class="text-success" @click.prevent="itemAction('restore-row', rowData.id, rowField.model, rowData)">{{ 'Restore' | translate }}</a>
  </div>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      required: false
    },
    rowField: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  computed: {
    isDeleted: function () {
      return this.rowData && this.rowData.deleted_at !== null && this.rowData.deleted_at !== undefined
    }
  },
  methods: {
    inputType: (field) => {
      switch (field) {
        case 'delete':
          return {type: 'delete'}
        case 's':
          return {type: 'number'}
        case 'shrink':
        case 'tm':
        case 'dybm':
        case 'tbm':
          return {type: 'number'}
        case 'dn':
        case 'dimension':
          return {type: 'readonly'}
        default:
          return {type: 'text'}
      }
    },
    itemAction (action, id, field, data) {
      this.$parent.$parent.$emit('data-changed', action, id, field, data)
    }
  }
}
</script>

<style scoped>
.pipe-deleted {
  text-decoration: line-through;
}
</style>



// WEBPACK FOOTER //
// PipeTableField.vue?30482094